import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const Translation = props => {
    const { labelName, defaultText, translationData, isOption, optionVal } = props;
    const renderText = translationData && typeof labelName === 'string' && translationData[labelName.trim()] ? translationData[labelName.trim()] : defaultText;
    return isOption ? (<option value={optionVal || ''}>{ renderText }</option>) : renderText;
}


const mapStateToProps = ({ languagesState }) => ({
    translationData: languagesState.translationData
});

export default connect(mapStateToProps, null)(Translation);

Translation.propTypes = {
    translationData: PropTypes.object,
    defaultText: PropTypes.string,
    labelName: PropTypes.string,
    isOption: PropTypes.bool,
    optionVal: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/Translation.js